export default __webpack_public_path__ + "static/media/cover (3).dc216a0e.svg";